/**
 * Testing Tools UI is only for non-production backoffice builds.
 * Backend endpoints are separately gated by BackendEnv DEV/STAGE.
 */
export function isTestingToolsUiEnabled (): boolean {
  const env = process.env.NEXT_PUBLIC_BACKOFFICE_ENV;
  return env === 'dev' || env === 'stage';
}
